import { render, staticRenderFns } from "./ColumnContent.vue?vue&type=template&id=3803d0c5&scoped=true&"
import script from "./ColumnContent.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ColumnContent.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ColumnContent.vue?vue&type=style&index=0&id=3803d0c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3803d0c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3803d0c5')) {
      api.createRecord('3803d0c5', component.options)
    } else {
      api.reload('3803d0c5', component.options)
    }
    module.hot.accept("./ColumnContent.vue?vue&type=template&id=3803d0c5&scoped=true&", function () {
      api.rerender('3803d0c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/footer-pages/ColumnContent.vue"
export default component.exports